import { render, staticRenderFns } from "./LoginNewsList.vue?vue&type=template&id=6f848877"
import script from "./LoginNewsList.vue?vue&type=script&lang=ts"
export * from "./LoginNewsList.vue?vue&type=script&lang=ts"
import style0 from "./LoginNewsList.vue?vue&type=style&index=0&id=6f848877&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports